import { ICardBrand } from './cardBrand.interface';
import { cardBrands } from './cardBrands.constant';

export function getCardBrandFromAPIName(name = 'Unknown'): ICardBrand {
    const cardBrand = Object.values(cardBrands).find(
        (cb: ICardBrand) => cb.apiName.toLowerCase() === name.toLowerCase(),
    );

    return cardBrand || cardBrands.UNKNOWN;
}
